// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React, { useCallback } from "react";
import { connect } from "react-redux";
import { Portal } from "@chakra-ui/react";

import { DeleteModal as StyledDeleteModal, PrimaryButton } from "./styles";
import { Overlay } from "src/styles/modal";
import Icon from "src/components/Icon";
import * as colors from "src/styles/constants/colors";
import { Form, SecondaryFooter } from "src/styles/form";
import { Secondary } from "src/styles/buttons";
import {
  FormGroup,
  ModalFormBody
} from "src/components/chatroom-nav/filter/styles";
import { deleteDashboard } from "src/actions/dashboard";
import { iconSize } from "src/styles/constants/size";
import ButtonLoader from "src/components/ButtonLoader";

import type { AppState } from "src/types";

type Props = {
  id: number,
  title: string,
  handleClose: Function,
  _deleteDashboard: Function
};

const DeleteModal = ({ id, title, handleClose, _deleteDashboard }: Props) => {
  const handleSubmit = useCallback(
    (event: any) => {
      event.preventDefault();
      _deleteDashboard(id);
      handleClose();
    },
    [handleClose]
  );

  return (
    <Portal>
      <Overlay />
      <StyledDeleteModal>
        <Form onSubmit={handleSubmit}>
          <h4>
            {i18n.t(k.DELETE_DASHBOARD)}
            <Icon
              icon="close"
              color={colors.primary}
              onClick={handleClose}
              size={iconSize.space_l}
            />
          </h4>
          <ModalFormBody>
            <FormGroup>
              <div>
                {i18n.t(k.ARE_YOU_SURE_YOU_WANT_TO_DELET)}{" "}
                <strong>{title}</strong>
              </div>
              <div>{i18n.t(k.PINNED_CHARTS_WILL_NOT_BE_DELE)}</div>
            </FormGroup>
          </ModalFormBody>
          <SecondaryFooter>
            <Secondary type="button" onClick={handleClose}>
              {i18n.t(k.CANCEL)}
            </Secondary>
            <PrimaryButton delete>
              <ButtonLoader
                type="submit"
                isLoading={false}
                color={colors.danger}
              >
                {i18n.t(k.DELETE)}
              </ButtonLoader>
            </PrimaryButton>
          </SecondaryFooter>
        </Form>
      </StyledDeleteModal>
    </Portal>
  );
};

const mapStateToProps = ({ app }: { app: AppState }) => ({
  title: app.dashboard.metaData.title
});

export default connect(mapStateToProps, { _deleteDashboard: deleteDashboard })(
  DeleteModal
);
